<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Product', apiMethod: 'Products', form: () => import('../forms/ProductForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Product Dispatch', apiMethod: 'ProductDispatches', parentForeignKey: 'productId', form: () => import('../forms/ProductDispatchForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Sampling', apiMethod: 'Samplings', parentForeignKey: 'productId', form: () => import('../forms/SamplingForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Dispatches', value: 'productId', isCard: true, table: () => import('../tables/ProductDispatchesTable') },
                    { text: 'Samplings', value: 'productId', isCard: true, table: () => import('../tables/SamplingsTable') },
                ],
                mainForm: () => import('../forms/ProductForm'),
                claimName: 'Products',
                apiMethod: 'Products',
            }
        }
    };
</script>
